import { FormikErrors, withFormik } from 'formik';
import UserSignupForm from './UserSignupForm';
import { UserSignupFormValues } from '../../../lib/signup/types';
import { clientCachedSubscriber } from '../../../lib/withApollo';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Props {}

export type State = UserSignupFormValues;

export const defaultState: State = {
  firstName: '',
  lastName: '',
  nickname: '',
  email: '',
  password: '',
  areaOfMinistries: [],
  emailConsent: true,
};

const mapPropsToValues = (_props: Props): State => {
  return clientCachedSubscriber() || defaultState;
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

const validate = (values: State): FormikErrors<State> => {
  const errors: FormikErrors<State> = {};

  if (!values.firstName) {
    errors.firstName = 'First Name is required.';
  }
  if (!values.lastName) {
    errors.lastName = 'Last Name is required.';
  }
  if (!values.nickname) {
    errors.nickname = 'Nickname is required.';
  } else if (values.nickname.length < 3) {
    errors.nickname = 'Nickname must be at least 3 characters.';
  } else if (values.nickname.length > 30) {
    errors.nickname = 'Nickname must not be longer than 30 characters.';
  }
  if (!values.email) {
    errors.email = 'Email is required.';
  } else if (!values.email.match(emailRegex)) {
    errors.email = 'Enter a valid email.';
  }
  if (!values.password) {
    errors.password = 'Password is required.';
  } else if (values.password.length < 8) {
    errors.password = 'Password must be at least 8 characters.';
  }
  if (values.areaOfMinistries.length === 0) {
    errors.areaOfMinistries = 'Area of Ministry is required.';
  } else if (values.areaOfMinistries.some(area => !area.label)) {
    errors.areaOfMinistries = 'Other is required.';
  }
  return errors;
};

export default withFormik<Props, State>({
  mapPropsToValues,
  validateOnChange: false,
  validate,
  handleSubmit: () => undefined,
})(UserSignupForm);
